import { mobileOnly } from '@styles/breakpoints';
import { css } from '@emotion/css'
import colors from '@v2/styles/colors';

export default css({
    padding: '29px 29px 21px 29px',
    display: 'flex',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    [mobileOnly]: {
        flexDirection: 'column',
    },
    '> div': {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        '.personalized-header': {
            color: colors.BLUE,
            fontWeight: 'bold',
            fontSize: 12,
            lineHeight: '16px',
            letterSpacing: '0.2em',
            textTransform: 'uppercase',
            marginBottom: 15,
        },
        '.personalized-body': {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            justifyContent: 'center',
            '> span': {
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                marginBottom: 8,
            }
        },
        [mobileOnly]: {
            '.personalized-body': {
                marginBottom: 15,
            }
        },
        '.brain-region': {
            backgroundColor: colors.BLUE_EXTRA_LIGHT,
            width: 33,
            height: 33,
            borderRadius: 50,
            position: 'relative',
            'picture': {
                position: 'absolute',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                maxWidth: '90%',
                height: 'auto',
                marginTop: 2,
                marginRight: 2,
            }
        },
        '.months-count': {
            backgroundColor: colors.BLUE_EXTRA_LIGHT,
            width: 33,
            height: 33,
            borderRadius: 50,
        },
        '.developmental-focus': {
            backgroundColor: colors.BLUE_EXTRA_LIGHT,
            width: 33,
            height: 33,
            borderRadius: 50,
            position: 'relative',
        },
        '&."personalized-developmental-info"': {
            [mobileOnly]: {
                order: 1,
            }
        },
        '&.personalized-region-info': {
            [mobileOnly]: {
                order: 2,
            }
        },
        '&.personalized-age-info': {
            [mobileOnly]: {
                order: 3,
            }
        },
        '&.personalized-nutrients-info': {
            [mobileOnly]: {
                order: 4,
            }
        },
    },
    '.personalized-nutrients-info': {
        '.personalized-body': {
            '.title': {
                color: colors.NAVY,
                fontWeight: 'bold',
                fontSize: 14,
                lineHeight: '145%',
                letterSpacing: '0.01em',
                textTransform: 'capitalize',
            },
            'div[class^="ing-square"]': {
                width: 30,
                height: 30,
            },
        }
    }
});
